/**
 * Busca no catálogo Font Awesome Pro (assets/auxiliary/fontawesome/metadata/catalog.json), que é em inglês.
 * O vocabulário do sistema (naturezas e papéis de envolvido, viaturas, locais) é pequeno e conhecido, então um
 * glossário PT→EN fixo cobre a busca em português sem depender de serviço externo.
 *
 * Linha do catálogo: [nome, rótulo, termos de busca, estilos disponíveis ("s" sólido, "r" regular, "l" leve)].
 */
const STYLE_CLASS = { s: 'fa-solid', r: 'fa-regular', l: 'fa-light' }

const GLOSSARY = {
  pessoa: ['person', 'user'],
  vitima: ['patient', 'injured', 'user-injured'],
  suspeito: ['mask', 'user-secret', 'secret'],
  testemunha: ['eye', 'user'],
  veiculo: ['car', 'truck'],
  carro: ['car'],
  moto: ['motorcycle'],
  caminhao: ['truck'],
  onibus: ['bus'],
  ambulancia: ['ambulance'],
  bombeiro: ['fire', 'fire-extinguisher'],
  policia: ['police', 'shield', 'badge'],
  objeto: ['box', 'cube'],
  imovel: ['house', 'building', 'home'],
  casa: ['house', 'home'],
  predio: ['building'],
  celular: ['mobile', 'phone', 'smartphone'],
  telefone: ['phone'],
  arma: ['gun', 'pistol', 'knife'],
  faca: ['knife'],
  droga: ['pills', 'syringe', 'cannabis'],
  dinheiro: ['money', 'dollar'],
  documento: ['file', 'id-card', 'passport'],
  crianca: ['child', 'baby'],
  idoso: ['person-cane', 'elderly'],
  gestante: ['person-pregnant', 'pregnant'],
  animal: ['paw', 'dog', 'cat'],
  cachorro: ['dog'],
  incendio: ['fire', 'flame'],
  fogo: ['fire', 'flame'],
  agua: ['water', 'droplet'],
  hospital: ['hospital', 'house-medical'],
  medico: ['user-doctor', 'stethoscope'],
  enfermeiro: ['user-nurse'],
  coracao: ['heart'],
  sangue: ['droplet', 'blood'],
  bandeira: ['flag'],
  alerta: ['triangle-exclamation', 'warning'],
  camera: ['camera', 'video'],
  chave: ['key'],
  mochila: ['backpack'],
  bicicleta: ['bicycle'],
  barco: ['ship', 'boat'],
  aviao: ['plane'],
  helicoptero: ['helicopter'],
}

export function normalize(text) {
  return String(text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
}

/** Termos aceitos para cada palavra digitada: ela mesma mais as traduções do glossário. */
function expand(word) {
  return [word, ...(GLOSSARY[word] || [])]
}

/** Pontua um ícone para um termo; 0 = não casa. Nome exato pesa mais que termo de busca. */
function score(row, term) {
  const [name, label, terms] = row
  if (name === term) return 100
  if (name.startsWith(term)) return 60
  if (name.split('-').some(part => part.startsWith(term))) return 40
  if (normalize(label).includes(term)) return 30
  if (terms.includes(term)) return 20

  return 0
}

/**
 * @param {Array} catalog  linhas do catalog.json
 * @param {string} query  texto digitado (PT ou EN)
 * @returns {Array}  linhas ordenadas por relevância (todas as palavras precisam casar)
 */
export function searchIcons(catalog, query, limit = 60) {
  const words = normalize(query).split(/\s+/).filter(Boolean)
  if (!words.length) return []

  const hits = []
  catalog.forEach(row => {
    const scores = words.map(word => Math.max(...expand(word).map(t => score(row, t))))
    if (scores.every(n => n > 0)) hits.push([scores.reduce((a, b) => a + b, 0), row])
  })

  return hits
    .sort((a, b) => b[0] - a[0] || a[1][0].localeCompare(b[1][0]))
    .slice(0, limit)
    .map(h => h[1])
}

/** Estilos do ícone, já como classe ("fa-solid"…), na ordem sólido, regular, leve. */
export function styleClasses(row) {
  return row[3].split('').map(s => STYLE_CLASS[s])
}

export function iconClass(style, name) {
  return `${style} fa-${name}`
}
